import AppHeaderLink, {
  AppHeaderLinkType,
} from "../../shared/src/components/AppHeader/AppHeaderLink";
import { AppRouteProps } from "../../shared/src/models";
import EUFinance from "../pages/EUFinance";
import EUFinanceCaseAttachmentDownloader from "../pages/EUFinanceCaseAttachmentDownloader";
import EUFinanceCaseAttachmentUploader from "../pages/EUFinanceCaseAttachmentUploader";
import EUFinanceCaseAttachmentViewer from "../pages/EUFinanceCaseAttachmentViewer";
import EUFinancePath from "./EUFinancePath";

export const EUFinanceAppRoutes: AppRouteProps[] = [
  {
    ...EUFinancePath.EUFinance,
    exact: true,
    render: () => <EUFinance />,
  },
  {
    ...EUFinancePath.EUFinanceCaseAttachmentDownloader,
    exact: true,
    hideHeader: true,
    render: () => <EUFinanceCaseAttachmentDownloader />,
  },
  {
    ...EUFinancePath.EUFinanceCaseAttachmentUploader,
    exact: true,
    hideHeader: true,
    render: () => <EUFinanceCaseAttachmentUploader />,
  },
  {
    ...EUFinancePath.EUFinanceCaseAttachmentViewer,
    exact: true,
    hideHeader: true,
    render: () => <EUFinanceCaseAttachmentViewer />,
  },
];

export const EUFinanceAppHeaderLinks: AppHeaderLink[] = [
  {
    ...EUFinancePath.EUFinance,
    type: AppHeaderLinkType.LINK,
  },
];
